import { createContext, useContext } from 'react';
import type { MetadataFetcher } from '../../../helpers';

export type CustomFetchers = Record<string, MetadataFetcher>;
interface CustomFetchersContext {
  customMetadataFetchers?: CustomFetchers;
}

export const CustomMetadataFetchersContext =
  createContext<CustomFetchersContext>({
    customMetadataFetchers: {}
  });

export const useCustomMetadataFetchers = () => {
  return useContext(CustomMetadataFetchersContext);
};
